$(document).ready(function(){
           setTimeout( function () {
          var subscription_value = $('.subscription-radio .rc-radio__subscription').text();
              $('.onetime-radio .rc-radio__label').html('<strong>One-time purchase</strong>');
              $('.subscription-radio .rc-radio__subscription').html('<strong>'+subscription_value+'</strong>');
               $('.onetime-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">No Subscription</p>');
               $('.subscription-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">Pause & cancel anytime.</p>');
               var Product_price = $('.ProductOTP-Price').text();
              $('.onetime-radio .rc-radio__label').after('<span class="rc-radio__price_one"><strong>'+Product_price+'</strong></span>');
              var onetime_servingprice = $('.ontime-priceserving').text();
              $('.onetime-radio .Guarantee__Text').after('<p class="onetime_priceWrapper">($'+ onetime_servingprice +'/serving)</p>');
               var subscription_servingprice = $('.subscription-priceserving').text();
              $('.subscription-radio .Guarantee__Text').after('<p class="subscribe_priceWrapper">($'+ subscription_servingprice +'/serving)</p>');
              $('.rc-radio__label .rc-radio__price').after('<span class="Subscription__Price Subscription_ComparisionPrice Heading u-h6 FontWeight_Six"></span>');
             if ($('.onetime-radio span.rc-radio__price_one').length > 0) {
          	  document.querySelector('.Subscription__Price.Subscription_ComparisionPrice').textContent = document.querySelector('.onetime-radio span.rc-radio__price_one').textContent.trim();
             };
            $('.oke-w-mediaGridModule .oke-media--linked').removeAttr("role");
            $('.oke-mediaStrip-container.oke-w-mediaStrip').removeAttr("role");
            $('.oke-media--linked').removeAttr("role");
           $('.oke-w-reviews-list-item').each(function() {
             var negativeReview = $(this).find('.oke-helpful-vote-button--negative .oke-helpful-vote-counter').text();
             var positiveReview = $(this).find('.oke-helpful-vote-button--positive .oke-helpful-vote-counter').text();
            $(this).find('.oke-helpful-vote-button--negative').attr('aria-label', negativeReview);
            $(this).find('.oke-helpful-vote-button--positive').attr('aria-label', positiveReview);
           });
          }, 1600);
        });
        $(window).load(function(){
             var recommondedrating = $('.oke-w-header-content-module--left .oke-w-recommendsModule .oke-w-recommendsModule-value').html();
            console.log(recommondedrating);
            var Rating_value = $('.oke-w-header-content-module--left .oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').html();
        setTimeout( function () {
         $('.oke-w-recommendsModule .oke-w-recommendsModule-value').remove();
         $('.oke-w-recommendsModule .oke-w-recommendsModule-text').before('<span class="oke-w-recommendsModule-value"><strong>'+ recommondedrating +'</strong></span>');
        $('.oke-w-selectAttr-item-title').remove();
         $('.oke-w-reviews-list-item .oke-w-selectAttr-item-value').before('<span class="oke-w-selectAttr-item-title"><strong>I DRINK PIQUE FOR</strong></span>');
           $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').remove();
          $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-stars').before('<span class="oke-w-ratingAverageModule-rating-average"><strong>'+ Rating_value +'</strong></span>');
        },500);
        })

document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".pt_456_tabs");
  const panels = document.querySelectorAll(".ProductIngre_TabPanel");

  // Default: show first panel
  panels.forEach((panel, index) => {
    panel.classList.toggle("visible", index === 0);
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove("pt_456_tabs_active"));

      // Add active class to clicked tab
      this.classList.add("pt_456_tabs_active");
      this.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

      // Show only the matching panel
      panels.forEach((panel, i) => {
        panel.classList.toggle("visible", i === index);
      });

    });
  });

});

/* Product gallery slider Mobile */
!function () {
  "use strict";

  // Poll until a condition is met, then resolve. Times out after `timeout` ms.
  function waitFor(condition, timeout) {
    timeout = timeout || 10000;
    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (condition()) {
          resolve(condition());
          clearInterval(interval);
          interval = null;
        }
      }, 500);
      setTimeout(function () {
        if (interval !== null) {
          clearInterval(interval);
          console.log("slider-width: condition not met before timeout");
        }
      }, timeout);
    });
  }

  function applyWidth() {
    var slideshow = document.querySelector(
      ".Product__Gallery .Product__Slideshow--zoomable"
    );
    if (!slideshow) return;

    // Set each cell to 83.333% width
    slideshow.querySelectorAll(".Carousel__Cell").forEach(function (cell) {
      cell.style.width = "83.333%";
    });

    // Resize Flickity so it recalculates positions with the new widths
    var flkty = Flickity.data(slideshow);
    if (flkty) flkty.resize();
  }

  waitFor(function () {
    return (
      window.innerWidth < 768 &&
      document.querySelector(
        ".Product__Gallery .Product__Slideshow--zoomable"
      ) != null && typeof Flickity === "function"
    );
  }).then(applyWidth);
}();


/* Product accordion to tab setup */
!function () {
  "use strict";
  function waitFor(condition, timeout) {
    timeout = timeout || 10000;
    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (condition()) {
          resolve(condition());
          clearInterval(interval);
          interval = null;
        }
      }, 500);
      setTimeout(function () {
        if (interval !== null) {
          clearInterval(interval);
          console.log("pt_472 accordion: condition not met before timeout");
        }
      }, timeout);
    });
  }

  // HTML templates
  var html = {
    accorTags: function (label) {
      return '<div class="pt_472_accor">' + label + "</div>";
    },
    accordianWrapper: function (inner) {
      return '<div class="pt_472_accordian_wrapper">' + inner + "</div>";
    },
    accorPopupOverlay: '<div class="pt_472_accordian_overlay"></div>',
    accorPopup: function (title, content) {
      return (
        '<div class="pt_472_accordian_popup">' +
        '<div class="pt_472_popup_header">' +
        "<h3>" + title + "</h3>" +
        '<div class="pt_472_popup_close"><img src="https://cdn-3.convertexperiments.com/uf/1002628/10024732/image-1_698d8dc47a009.png"></div>' +
        "</div>" +
        '<div class="pt_472_accorPopup_content Product__Tabs ProductDetail__Tab">' +
        content +
        "</div>" +
        "</div>"
      );
    },
    atcPopupOverlay: '<div class="pt_472_atc_overlay"></div>',
    atcPopup: function (title, handle) {
      return (
        '<div class="pt_472_atc_popup" data-product-handle="' + (handle || "") + '">' +
        '<div class="pt_472_atc_header">' +
        "<h3>" + title + "</h3>" +
        '<div class="pt_472_atc_close"><img src="https://cdn-3.convertexperiments.com/uf/1002628/10024732/image-1_698d8dc47a009.png"></div>' +
        "</div>" +
        '<div class="pt_472_atc_content"></div>' +
        "</div>"
      );
    },
  };

  function buildAccordion(root) {
    waitFor(function () {
      return (
        root.querySelector(".Product__Tabs button.Collapsible__Button") != null &&
        root.querySelector(".ProductForm ~ .ProductMeta__Description") != null &&
        root.querySelector(".footbar-fixed-product .Sticky__Form") != null &&
        (root.querySelector(".Container .ProductForm .liquid") != null ||
          (window.location.pathname === "/products/cacao-chai" &&
            root.querySelector(".ProductForm .ProductForm__AddToCart")))
      );
    }).then(function () {
      if (root.querySelector(".pt_472_accordian_wrapper")) return;

      var isCacaoChai = window.location.pathname === "/products/cacao-chai";
      var isNandaka =
        window.location.pathname ===
        "/products/nandaka-coffee-alternative-14ct";

      if (isCacaoChai) root.classList.add("pt_472_cacao_chai_pdp");

      // Where to inject the inline (non-sticky) wrapper
      var anchor = isCacaoChai
        ? root.querySelector(".ProductForm .ProductForm__AddToCart")
        : isNandaka
        ? root.querySelector(".Container .ProductForm .liquid:last-of-type")
        : root.querySelector(".Container .ProductForm .liquid");

      var stickyForm = root.querySelector(
        ".footbar-fixed-product .Sticky__Form"
      );
      if (!anchor || !stickyForm) return;

      // Close handler for the popup
      function closePopup() {
        var overlay = root.querySelector(".pt_472_accordian_overlay");
        var popup = root.querySelector(".pt_472_accordian_popup");
        overlay && overlay.classList.remove("pt_472_accordian_active");
        popup && popup.classList.remove("pt_472_accordian_active");
        root.classList.remove("pt_472_accor_popup_open");
      }

      // Build the tab strip: "Benefits" first, then each Collapsible tab label
      var tabsHtml = '<div class="pt_472_accor pt_472_accor_active">Benefits</div>';
      root
        .querySelectorAll(".Product__Tabs button.Collapsible__Button")
        .forEach(function (btn) {
          var label = btn.textContent.trim().toLowerCase();
          // Skip the guarantee tab entirely (handled via the tooltip instead)
          if (label === "100% happiness guarantee") return;
          tabsHtml += html.accorTags(label);
        });

      // Inject overlay + both wrappers (inline copy and sticky-bar copy)
      root.insertAdjacentHTML("beforeend", html.accorPopupOverlay);
      anchor.insertAdjacentHTML(
        "beforebegin",
        html.accordianWrapper(tabsHtml)
      );
      stickyForm.insertAdjacentHTML(
        "afterbegin",
        html.accordianWrapper(tabsHtml)
      );

      // Wire up each tab
      root.querySelectorAll(".pt_472_accor").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var label = this.textContent.trim().toLowerCase();

          // Sync active state across both wrappers
          root
            .querySelectorAll(".pt_472_accor")
            .forEach(function (t) {
              t.classList.remove("pt_472_accor_active");
            });
          root.querySelectorAll(".pt_472_accor").forEach(function (t) {
            if (t.textContent.trim().toLowerCase() === label) {
              t.classList.add("pt_472_accor_active");
            }
          });

          // Resolve title + content for this tab
          var title = label;
          var content = "";

          if (label === "benefit" || label === "benefits") {
            title = "Benefits";
            var desc = root.querySelector(
              ".ProductForm ~ .ProductMeta__Description"
            );
            content = desc ? desc.outerHTML : "";
          } else {
            var match = Array.prototype.slice
              .call(root.querySelectorAll(".Product__Tabs .Collapsible__Button"))
              .find(function (b) {
                return b.textContent.trim().toLowerCase() === label;
              });
            if (match) {
              var collapsibleContent = match
                .closest(".Collapsible")
                .querySelector(".Collapsible__Content");
              content = collapsibleContent ? collapsibleContent.outerHTML : "";
            }
          }

          // Open / update popup
          var overlay = root.querySelector(".pt_472_accordian_overlay");
          var popup = root.querySelector(".pt_472_accordian_popup");

          if (popup) {
            popup.querySelector(".pt_472_popup_header h3").textContent = title;
            popup.querySelector(".pt_472_accorPopup_content").innerHTML = content;
          } else {
            root.insertAdjacentHTML(
              "beforeend",
              html.accorPopup(title, content)
            );
            popup = root.querySelector(".pt_472_accordian_popup");
            popup
              .querySelector(".pt_472_popup_close")
              .addEventListener("click", closePopup);
            overlay.addEventListener("click", closePopup);
          }

          overlay.classList.add("pt_472_accordian_active");
          popup.classList.add("pt_472_accordian_active");
          root.classList.add("pt_472_accor_popup_open");
        });
      });

      // Delegate clicks inside the popup to the real reviews carousel button
      document.addEventListener("click", function (e) {
        if (
          e.target.closest(
            ".pt_472_accorPopup_content a.okeReviews-reviewsCarousel-btn"
          )
        ) {
          var realBtn = root.querySelector(
            ".Container > .ProductDetail__Tab a.okeReviews-reviewsCarousel-btn"
          );
          realBtn && realBtn.click();
        }
      });
    });
  }

  /* ---------------------------------------------------------------
   * PT_472 — Sticky Add To Cart popup (mobile only)
   * Clones the real ATC button into the sticky bar; clicking it opens
   * a popup containing a clone of the product form.
   * ------------------------------------------------------------- */
  function buildStickyAtc(root) {
    waitFor(function () {
      return (
        root.querySelector(".Sticky__Form > .Container") != null &&
        root.querySelector(".ProductForm button.ProductForm__AddToCart") != null &&
        (root.querySelector(".ProductForm .liquid") != null ||
          (window.location.pathname === "/products/cacao-chai" &&
            root.querySelector(".ProductForm .ProductForm__AddToCart")))
      );
    }).then(function () {
      if (root.querySelector(".pt_472_atc_popup")) return;

      var isCacaoChai = window.location.pathname === "/products/cacao-chai";

      // Clone the real ATC button into the sticky bar
      var realAtc = root.querySelector(
        ".ProductForm button.ProductForm__AddToCart"
      );
      if (!realAtc) return;
      var isBundle =
        realAtc.hasAttribute("data-bundle-data") ||
        realAtc.getAttribute("aria-haspopup") === "dialog" ||
        realAtc.classList.contains("pdpBundleBtn");

      var clone = realAtc.cloneNode(true);
      clone.classList.add("pt_472_is_sticky_clone");
      clone.type = "button";
      clone.classList.remove("ProductForm__AddToCart");
      // Strip add/bundle hooks from the clone so it can never add to cart itself
      clone.removeAttribute("data-bundle-data");
      clone.removeAttribute("data-add-to-cart");
      clone.removeAttribute("data-var_id");
      clone.removeAttribute("name");
      clone.removeAttribute("aria-haspopup");
      root
        .querySelector(".Sticky__Form > .Container")
        .insertAdjacentElement("afterbegin", clone);

      // Build popup from a clone of the product form
      var title = root
        .querySelector(".ProductMeta .ProductMeta__Title")
        .textContent.trim();

      // Current product handle from the URL (/products/<handle>)
      var productHandle = (window.location.pathname.split("/products/")[1] || "")
        .split("/")[0]
        .split("?")[0];

      function rebuildPopupContent() {
        var content = root.querySelector(".pt_472_atc_content");
        if (!content) return null;
        var form = root.querySelector(".Container form.ProductForm");
        var formClone = form ? form.cloneNode(true) : null;
        content.innerHTML = "";
        if (formClone) content.appendChild(formClone);
        wirePopupForm(content);
        return content;
      }

      function openAtc() {
        rebuildPopupContent();
        root.querySelector(".pt_472_atc_overlay").classList.add("pt_472_atc_active");
        root.querySelector(".pt_472_atc_popup").classList.add("pt_472_atc_active");
        root.classList.add("pt_472_atc_open");
      }
      function closeAtc() {
        root.querySelector(".pt_472_atc_overlay").classList.remove("pt_472_atc_active");
        root.querySelector(".pt_472_atc_popup").classList.remove("pt_472_atc_active");
        root.classList.remove("pt_472_atc_open");
      }

      // Per-open wiring for the freshly cloned form inside the popup.
      function wirePopupForm(content) {
        // Reveal one-time purchase block inside the cloned form
        var onetime = content.querySelector(".liquid .pt_413_onetime_wrapper");
        if (onetime) onetime.classList.remove("pt_413_hidden");

        var toggle = root.querySelector("#sticky_toggleCheckbox");

        // Clicking either purchase option in the popup toggles the real label
        content.addEventListener("click", function (e) {
          var target = e.target;
          if (
            target.closest(".pt_413_onetime_wrapper") ||
            target.closest(".pt_413_subscription_wrapper")
          ) {
            if (toggle) toggle.closest('label[for="sticky_toggleCheckbox"]').click();
          }
        });

        // Popup ATC button
        var popupAtc = content.querySelector("button.ProductForm__AddToCart");
        if (popupAtc) {
          if (isBundle) {
            popupAtc.removeAttribute("data-bundle-data");
            popupAtc.removeAttribute("data-add-to-cart");
            popupAtc.removeAttribute("data-var_id");
            popupAtc.removeAttribute("name");
            popupAtc.removeAttribute("aria-haspopup");
            popupAtc.type = "button";
            popupAtc.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
              closeAtc();
              var realBundle = root.querySelector(
                ".Container form.ProductForm button.ProductForm__AddToCart"
              );
              if (realBundle) realBundle.click();
            });
          } else {
            // Standard product: forward the click to the real form's ATC.
            popupAtc.addEventListener("click", function (e) {
              e.preventDefault();
              waitFor(function () {
                return (
                  root.querySelector(
                    ".Container > form.ProductForm button.ProductForm__AddToCart"
                  ) != null
                );
              }).then(function () {
                root
                  .querySelector(
                    ".Container > form.ProductForm button.ProductForm__AddToCart"
                  )
                  .click();
              });
            });
          }
        }
      }

      root.insertAdjacentHTML("beforeend", html.atcPopupOverlay);
      root.insertAdjacentHTML("beforeend", html.atcPopup(title, productHandle));

      // Close handlers
      root.querySelector(".pt_472_atc_close").addEventListener("click", closeAtc);
      root.querySelector(".pt_472_atc_overlay").addEventListener("click", closeAtc);

      var content = root.querySelector(".pt_472_atc_content");

      if (isCacaoChai) {
        // cacao-chai: sticky clone fires the real ATC directly (no popup form)
        var stickyClone = root.querySelector(".pt_472_is_sticky_clone");
        stickyClone &&
          stickyClone.addEventListener("click", function (e) {
            e.preventDefault();
            var real = root.querySelector(
              ".Product__InfoWrapper .ProductForm__AddToCart"
            );
            real && real.click();
          });
      } else if (isBundle) {
        var stickyBundleClone = root.querySelector(
          ".Sticky__Form .pt_472_is_sticky_clone"
        );
        stickyBundleClone &&
          stickyBundleClone.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var realBundle = root.querySelector(
              ".Container form.ProductForm button.ProductForm__AddToCart"
            );
            if (realBundle) realBundle.click();
          });
      } else {
        // Sticky clone opens the popup (content is rebuilt fresh on each open)
        root
          .querySelector(".Sticky__Form .pt_472_is_sticky_clone")
          .addEventListener("click", openAtc);

        // Sync the subscription/one-time toggle state
        var toggle = root.querySelector("#sticky_toggleCheckbox");
        if (toggle) {
          if (!toggle.checked) root.classList.add("stickyToogle_enabled");
          toggle.addEventListener("change", function (e) {
            root.classList.toggle("stickyToogle_enabled", !e.target.checked);
          });
        }

        // Lower CTA in the inline form mirrors the toggle switch
        var lowerCta = root.querySelector(
          ".Container > .ProductForm .liquid p.pt_413_onetime_left_lower_cta"
        );
        if (lowerCta) {
          lowerCta.addEventListener("click", function () {
            var sw = root.querySelector(
              ".Container > .ProductForm .liquid .pt_413_onetime_wrapper .pt_413_toggle_switch"
            );
            if (sw) sw.click();
          });
        }
      }
    });
  }

  // Mobile-only entry point
  waitFor(function () {
    return (
      window.location.pathname.includes("/products/") &&
      window.innerWidth < 768 &&
      document.querySelector("main") !== null
    );
  }).then(function () {
    var root = document.body;
    root.classList.add("pt_472");
    buildAccordion(root);
    buildStickyAtc(root);
  });
}();

document.querySelectorAll('.SellingPlan__Selector').forEach(function (select) {
  function syncHiddenInput() {
    var scope = select.closest('[class*="bundleBaseCol"]') || select.closest('form') || document;
    var hiddenInput = scope.querySelector('input[name="selling_plan"]');
    if (hiddenInput) hiddenInput.value = select.value;
  }

  select.addEventListener('change', syncHiddenInput);
  syncHiddenInput();
});

/* Convert test 163 */
if (!window.op_pt_485_var_code_triggered) {
    window.op_pt_485_var_code_triggered = true;
    !function(){"use strict";!function(){function t(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2e4;return new Promise(function(n){var r=setInterval(function(){t()&&(n(t()),clearInterval(r),r=null)},100);setTimeout(function(){null!==r&&(clearInterval(r),console.log("condition false"))},e)})}var e=function(t,e){return t?console.log.bind(console,"".concat(e,":")):function(){}};function n(t){return function(t){if(Array.isArray(t))return r(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return r(t,e);var n={}.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function pt485EagerLoadFirstSlide(e){var n=e.querySelector('.Product__Gallery .Product__Slideshow--zoomable .Carousel__Cell:first-child img.Image--lazyLoad');n&&(n.setAttribute("fetchpriority","high"),n.setAttribute("decoding","async"),n.dataset.src&&n.getAttribute("src")!==n.dataset.src&&(n.src=n.dataset.src))}var o=function(t){var e=n(t.closest(".pt_472_accordian_wrapper").querySelectorAll(".pt_472_accor")),r=e.find(function(t){return t.textContent.trim().toLowerCase().includes("ingredients")}),o=e.find(function(t){return t.textContent.trim().toLowerCase().includes("how to")});r&&o&&!o.contains(r)&&!r.contains(o)&&o.insertAdjacentElement("afterend",r)},i=function(t){var e=t.querySelector(".pt_461_benefits_tag"),n=e.closest(".Carousel"),r=window.Flickity.data(n);r.on("dragStart",function(){0===r.selectedIndex&&e.classList.add("pt_485_fade-out_tags")}),r.on("dragEnd",function(){0===r.selectedIndex&&e.classList.remove("pt_485_fade-out_tags")}),r.on("settle",function(){0===r.selectedIndex&&e.classList.remove("pt_485_fade-out_tags")})},a=function(t){var e=t.closest(".Carousel"),n=window.Flickity.data(e);n.options.wrapAround=!0,n.resize()},c=function(e){t(function(){return e.querySelector(".Product__Wrapper .Product__Meta-mobile")&&e.querySelector(".Product__Wrapper .Product__Gallery")}).then(function(){return function(e){var r=e.querySelector(".Product__Meta-mobile"),c=e.querySelector(".Product__Wrapper .Product__Gallery"),u="/products/bt-fountain"===window.location.pathname,l="/products/nectar-sweetener"===window.location.pathname;u&&e.classList.add("pt_485_btFountainProduct"),c.contains(r)||r.contains(c)||c.insertAdjacentElement("afterend",r),t(function(){return c.querySelector(".Carousel.flickity-enabled")}).then(function(t){a(t)}),!l||l&&e.querySelector('.Carousel [data-media-position="1"] .pt_461_benefits_tag')?t(function(){return c.querySelector(".Carousel.flickity-enabled")&&c.querySelector(".Carousel .pt_461_benefits_tag")}).then(function(t){t.closest('[data-media-position="1"]')&&i(e)}):t(function(){return c.querySelector(".Carousel.flickity-enabled")&&c.querySelector('.Carousel [data-media-position="1"] div')}).then(function(t){var r=n(e.querySelectorAll(".ProductMeta .ProductMeta__Tags .Collection__Title")).slice(0,3);t.insertAdjacentHTML("afterbegin",'<div class="pt_461_benefits_tag"></div>');var o=r.map(function(t){return"<span>".concat(t.textContent.trim(),"</span>")}).join("");e.querySelector('.Carousel [data-media-position="1"] .pt_461_benefits_tag').insertAdjacentHTML("afterbegin",o),i(e)}),function(t){t.addEventListener("click",function(t){var e=t.target.closest(".pt_472_accordian_popup .okeReviews-reviewsCarousel-btn");if(e){var n=e.closest(".pt_472_accordian_popup").querySelector(".pt_472_popup_close");n&&n.click()}})}(e),t(function(){return e.querySelector(".Product__Wrapper .pt_472_accordian_wrapper .pt_472_accor")}).then(o),t(function(){return e.querySelector(".Sticky__Form .pt_472_accordian_wrapper .pt_472_accor")}).then(o)}(e)})};!function(n){!function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"v1";window.optiActiveTests=window.optiActiveTests||{},window.optiActiveTests[t]=e}(n,"v1");var r=e(!0,n);t(function(){return document.querySelector("body")}).then(function(t){window.innerWidth>767||!window.location.pathname.includes("/products/")||(t.classList.add("pt_485"),r("workflow fn called"),c(t))})}("PT_485")}()}();
}